import React, { useMemo } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Card, RocketIcon } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { CallToUpgradeLink } from "~/components/CallToUpgradeLink/CallToUpgradeLink";

const renderCard = (children, hasFeature, rightSide) => {
  return (
    <Card
      variant="paper-2"
      className={classNames("tw-min-h-[68px] tw-flex tw-items-center tw-justify-between", {
        "tw-pl-5 tw-pr-28 tw-py-4 tw-mb-1 tw-cursor-pointer tw-relative": !hasFeature,
        "tw-mb-1 tw-pl-5 tw-pr-4 tw-py-3": hasFeature,
      })}
    >
      {children}
      {hasFeature ? (
        rightSide
      ) : (
        <div
          className="tw-absolute tw-bg-primary tw-right-0 tw-top-0 tw-w-[105px] tw-h-full tw-rounded-r-lg call-to-upgrade-ribbon"
          style={{ clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 50% 100%)" }}
        >
          <RocketIcon
            className="tw-absolute tw-fill-body-bg-main"
            style={{ top: "50%", transform: "translateY(-50%)", right: "20px" }}
          />
        </div>
      )}
    </Card>
  );
};

export const CardOrCallToUpgradeCard = ({
  hasFeature,
  features,
  context,
  page,
  to,
  rightSide,
  onCardClick,
  children,
}) => {
  const renderCallToUpgradeLink = useMemo(() => {
    return <RouterLink className="tw-no-underline">{renderCard(children, hasFeature, rightSide)}</RouterLink>;
  }, [children, hasFeature, rightSide]);

  return hasFeature ? (
    <RouterLink
      onClick={onCardClick ?? null}
      to={to ?? null}
      className="tw-no-underline tw-w-full"
    >
      {renderCard(children, hasFeature, rightSide)}
    </RouterLink>
  ) : (
    <CallToUpgradeLink
      ownerChildren={renderCallToUpgradeLink}
      memberChildren={renderCallToUpgradeLink}
      features={features}
      context={context}
      page={page}
    />
  );
};

CardOrCallToUpgradeCard.propTypes = {
  imageSrc: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  hasFeature: PropTypes.bool,
  features: PropTypes.array,
  context: PropTypes.string,
  page: PropTypes.string,
  to: PropTypes.string,
  rightSide: PropTypes.node,
  onCardClick: PropTypes.func,
  children: PropTypes.node,
};
